import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.test';

@Injectable({
  providedIn: 'root',
})
export class AppManageService {
  private BASE_LINK = environment.BASE_LINK;
  private REDIRECT_LINK = environment.REDIRECT_LINK;

  detectarDispositivo(url: string): void {
    if (!url) {
      return;
    }

    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
      const URI = url.replace(this.BASE_LINK, this.REDIRECT_LINK);
      window.location.href = URI;
    }
  }
}
